import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useAuth from "../auth/useAuth";
import useRefreshToken from "./useRefreshToken";
import Loader from "../../Components/Loader";
import axiosDotnet from '../../services/axiosDotnet';

const PersistLogin = ()=>{
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const {auth} = useAuth();

    useEffect(() => {
           
        let isMounted = true;
        // console.log("PersistLogin");
        const verifyRefreshToken = async () => {
            try{
                await refresh();
            }
            catch(error){
                console.log(error);
            }
            finally{
                setIsLoading(false);
            }
        }
        verifyRefreshToken() ;
        return () => isMounted = false;
    },[])

    useEffect(() => {
        const token = auth?.accessToken?.trim().replace(/[\r\n]+/g, '');
        if (token) {
          axiosDotnet.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
          // Ensure header is removed when logging out
          delete axiosDotnet.defaults.headers.common['Authorization'];
        }
      }, [auth?.accessToken]);

    return (
        <div>
            {isLoading ? <Loader text="Loading AetherForge-Workspace ..."/> : <Outlet />}
        </div>
    )
}
export default PersistLogin;
